export interface ExportColumn<T> {
  key: keyof T | string;
  label: string;
  map?: (row: T) => string | number | boolean | null | undefined;
}

function escapeCell(value: unknown) {
  const raw = String(value ?? "");
  const normalized = raw.replace(/\r?\n/g, " ").trim();

  if (
    normalized.includes(",") ||
    normalized.includes('"') ||
    normalized.includes(";")
  ) {
    return `"${normalized.replace(/"/g, '""')}"`;
  }

  return normalized;
}

export function exportRowsToCsv<T>(
  filename: string,
  rows: T[],
  columns: ExportColumn<T>[]
) {
  const header = columns.map((column) => escapeCell(column.label)).join(",");

  const body = rows.map((row) =>
    columns
      .map((column) => {
        const value = column.map
          ? column.map(row)
          : (row as Record<string, unknown>)[String(column.key)];
        return escapeCell(value);
      })
      .join(",")
  );

  const csv = "\uFEFF" + [header, ...body].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}